import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NfListLoad, NfListSetFilter, NfListSetInitialState } from './nf-list.actions';
import { NfListState, NfListStateModel } from './nf-list.state';
import { NfSearchFilter, NfSearchRequest } from './models/nf-search.model';
import { NfSummaryResponse } from './models/nf-summary.model';

@Injectable({ providedIn: 'root' })
export class NfListFacade {
  state$: Observable<NfListStateModel> = this.store.select(NfListState.getState);
  items$: Observable<NfSummaryResponse[]> = this.store.select(NfListState.getItems);
  totalElements$: Observable<number> = this.store.select(NfListState.getTotalElements);
  loaded$: Observable<boolean> = this.store.select(NfListState.getLoaded);

  constructor(private store: Store) {}

  load(payload: NfSearchRequest): void {
    this.store.dispatch(new NfListLoad(payload));
  }

  setFilter(filter: Partial<NfSearchFilter>): void {
    this.store.dispatch(new NfListSetFilter(filter));
  }

  setInitialState(): void {
    this.store.dispatch(new NfListSetInitialState());
  }
}
